import { HARDWARE_STATUS, SEARCH } from 'constants/FilterConstants';
import type { DeviceStatusEnum } from 'modules/devices/constants';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import { getPersistedFilters } from 'services/StateLoader';
import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../../actionTypes';

type HardwaresFilters = {
  [SEARCH]: string | null;
  [HARDWARE_STATUS]: Array<DeviceStatusEnum>;
};

const persistedFilters = getPersistedFilters()?.filters?.hardwares ?? {};

const emptyState: HardwaresFilters = {
  [SEARCH]: null,
  [HARDWARE_STATUS]: [],
};

const filterAdapter = filterSliceAdapter(emptyState, persistedFilters);

export default createReducer<HardwaresFilters>(filterAdapter.getInitialState(), {
  [types.SET_HARDWARES_DASHBOARD_FILTER]: filterAdapter.setFilter,
  [types.SET_HARDWARES_DASHBOARD_FILTERS]: filterAdapter.setFilters,
  [types.CLEAR_HARDWARES_DASHBOARD_FILTER]: filterAdapter.resetFilters,
  [types.REMOVE_HARDWARES_DASHBOARD_FILTER]: filterAdapter.removeFilter,
});
